import React from 'react';
import propTypes from 'prop-types';

ActionButton.propTypes = {
  onAdd: propTypes.func,
  onRemove: propTypes.func
};

export default function ActionButton(props) {
  let { onAdd, onRemove, addActionBtnText} = props;
  if(onAdd){
    return(
      <div className="action-wrap add-to-trip" onClick={onAdd}>
        {addActionBtnText ? null : <i className="icon icon-add-bold" /> }
        <div className="add-to-trip-btn">{addActionBtnText || '加入行程'}</div>
      </div>
    );
  }
   
  if(onRemove){
    return(
      <div className="action-wrap add-to-trip" onClick={onRemove}>
        <div className="add-to-trip-btn">移出行程</div>
      </div>
    );
  } 

  return null; 
}


// WEBPACK FOOTER //
// ./src/components/CustomPoi/ActionButton.js